// extracted by mini-css-extract-plugin
export default {"drops":"drops_drops__MvrA4","dropsTitle":"drops_dropsTitle__Xukhz","dropItems":"drops_dropItems__7umWo"};